<script setup lang="ts">
/** Visual switch knob. The clickable element (with role="switch") is the parent. */
defineProps<{ on: boolean; size?: 'sm' | 'md' | 'lg' }>()
</script>

<template>
  <span class="sw" :class="[size && size !== 'sm' ? size : '', { on }]" aria-hidden="true"><span class="sw-k"></span></span>
</template>
